// Translations
import form from '../sections/form/translations/de'

// Translation: Reset > Landing (German)
export default Object.freeze({
	sections: { form }
})
